import React from "react";
import EnrollmentsNotPaid from "../EnrollmentsNotPaid";

const EnrollmentsNotPaidComponent = () => {
  return <EnrollmentsNotPaid title="Enrollments Not Yet Paid" />;
};

export default EnrollmentsNotPaidComponent;
